import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight, BookOpen } from "lucide-react";
import { Reveal } from "./Reveal";
import { ARTICLES, PILLARS } from "@/data/articles";

export default function JournalSection() {
  const latest = ARTICLES.slice(0, 2);

  return (
    <section id="journal" className="py-20 lg:py-28 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="grid grid-cols-12 gap-8 lg:gap-12 mb-12 items-end">
          <Reveal className="col-span-12 lg:col-span-5">
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-brand-teal font-semibold mb-4">
              The Clarity Journal
            </p>
            <h2 className="font-display font-semibold tracking-tight leading-[1.12] text-brand-navy text-2xl sm:text-3xl lg:text-4xl mb-5">
              Plain writing for busy owners.
            </h2>
            <p className="text-base text-slate-600 leading-relaxed">
              Short, honest pieces on running a calmer business. No jargon, no
              product pitches — just the ideas we use with clients.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="col-span-12 lg:col-span-4 lg:col-start-9 flex lg:justify-end">
            <Link
              to="/journal"
              data-testid="journal-browse-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-brand-navy border-b-2 border-brand-teal/40 pb-1 hover:border-brand-teal transition-colors duration-300"
            >
              Browse the whole journal
              <ArrowRight size={15} />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-7">
          {latest.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.08}>
              <Link
                to={`/journal/${a.slug}`}
                data-testid={`journal-card-home-${a.slug}`}
                className="group flex gap-5 rounded-2xl border border-slate-200 bg-[#F8FAFC] p-7 sm:p-8 h-full transition-all duration-300 hover:border-brand-teal hover:-translate-y-0.5 hover:shadow-[0_24px_48px_-20px_rgba(0,34,210,0.25)]"
              >
                <span className="w-10 h-10 rounded-full bg-brand-tealsoft text-brand-teal flex items-center justify-center shrink-0">
                  <BookOpen size={16} />
                </span>
                <span>
                  <span className="block font-mono text-[10px] uppercase tracking-[0.16em] text-slate-400 mb-2">
                    {PILLARS.find((p) => p.id === a.pillar)?.label} · {a.readTime}
                  </span>
                  <span className="block font-display font-semibold text-lg sm:text-xl text-brand-navy leading-snug mb-2 group-hover:text-brand-teal transition-colors duration-300">
                    {a.title}
                  </span>
                  <span className="block text-sm text-slate-600 leading-relaxed mb-3">{a.excerpt}</span>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-teal">
                    Read the article
                    <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
